import React, { Component } from "react";
import { Row, Col, Card, Button, Empty } from "antd";
import Category from "../../components/CategoriesCard";
import ShippingCost from "../../components/ShpingCost";
import CatalogCard from "../../components/catalogCard";
import { Store } from "../../store";
import { connect } from "react-redux";
import { CatalogAction } from "../../store/actions";
import General_Info from "../../components/generalInfo";
import RMX from "../../assets/images/b-RMX-1.png";
import "./Styles.css";
import CoverImage from "../../components/coverImage";
import ProductCard from "../../components/productCard";
class StorePreview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isClose: false,
      isOpenModal: false,
      filters: {
        order: "asc",
        page: 1,
        per_page: 12,
        column: "name",
        category_id: 1,
        status: "active",
      },
      categoryName: "Standard Products",

      shipingprice: {
        am_charges: "0.0",
        pm_charges: "0.0",
      },
      price: "",
    };
  }

  abc = (key) => {
    this.setState({
      filters: {
        ...this.state.filters,
        category_id: key.id,
      },
      categoryName: key.name,
    });
  };

  componentDidMount() {
    const {
      getProducts,
      getCategories,
      getShippingCost,
      basemixdata,
      getbasemixes,
      getadditives,
      getbasemixesCategories,
    } = this.props;
    getProducts(this.state.filters, true);
    getCategories();
    getShippingCost();
    basemixdata();
    getbasemixes();
    getadditives();
    getbasemixesCategories();
  }

  componentDidUpdate(preProps, preState) {
    const { getProducts } = this.props;

    if (preProps.metaData !== this.props.metaData) {
      this.setState({
        filters: {
          ...this.state.filters,
          page: this.props?.metaData?.current_page,
          totalCount: this.props?.metaData?.total_records,
          currentCount: this.props?.metaData?.current_records,
          total_pages: this.props?.metaData?.total_pages,
        },
      });
    }

    if (
      preState.filters.category_id !== this.state.filters.category_id ||
      preState.filters.column !== this.state.filters.column ||
      preState.filters.per_page !== this.state.filters.per_page ||
      preState.filters.page !== this.state.filters.page
    ) {
      getProducts(this.state.filters, true);
    }
    if (preProps.shipingprice !== this.props.shipingprice) {
      this.setState({
        shipingprice: {
          am_charges: this.props?.shipingprice?.am_charges,
          pm_charges: this.props?.shipingprice?.pm_charges,
        },
      });
    }
  }

  onChangeShowingFilter = (value) => {
    this.setState({
      filters: {
        ...this.state.filters,
        per_page: value,
      },
    });
  };

  onUpdateShippingCost = (e, type) => {
    this.setState({
      shipingprice: {
        ...this.state.shipingprice,
        [type]: e,
      },
    });
  };

  onUpdatePrice = (price) => {
    this.setState({
      price: price,
    });
  };

  onChangeFilter = (value) => {
    this.setState({
      filters: {
        ...this.state.filters,
        column: value,
      },
    });
  };

  render() {
    if (this?.props?.location?.state?.fromCustom) {
      return <General_Info />;
    }
    return (
      <Row>
        <Col xl={24} lg={24} xs={24} sm={24} md={24}>
          <Card>
            <Row>
              <Col
                span={12}
                style={{
                  padding: "15px",
                }}
              >
                <img
                  src={RMX}
                  style={{
                    width: "60%",
                    maxWidth: "100%",
                    height: "auto",
                    // position: "absolute",
                    backgroundRepeat: "no-repeat",
                    top: "-20px",
                  }}
                />
              </Col>
            </Row>
            <Row justify="center">
              <Col span={19}>
                <CoverImage
                //   keyTab={this.state.keyTab}
                //   userImage={
                //     keyTab == "2"
                //       ? this.props.companyDetails
                //       : this.props?.userDetail
                //   }
                //   CoverImage={
                //     this?.props?.companyDetails?.rmx_company_asset?.cover
                //       ?.original
                //   }
                //   onChangeCoverImage={(e) =>
                //     updateAssets(companyDetails?.rmx_company_asset?.id, {
                //       cover: e.target.files[0],
                //     })
                //   }
                //   onChangeBusinessImage={(e) => {
                //     updateAssets(companyDetails?.rmx_company_asset?.id, {
                //       logo: e.target.files[0],
                //     });
                //   }}
                //   onChangeProfileImage={(e) => {
                //     updateProfileInfo({ image: e.target.files[0] });
                //   }}
                />
              </Col>
            </Row>
            <Row justify="center">
              <Col xl={19}>
                <Row>
                  <Col xl={6} lg={8} xs={24} sm={24} md={8}>
                    <h6 className="text-left catalog-heading-register">
                      Store Preview
                    </h6>
                    <Category
                      abc={this.abc}
                      categorey={this.props.categories}
                      isImageTrue={true}
                      {...this.props}
                    />
                  </Col>
                  <Col xl={14} lg={8} xs={24} sm={24} md={8}>
                    <Row>
                      {this.props.products.length || [] ? (
                        this.props.products.map((item) => {
                          return (
                            <Col xl={8} lg={8} md={6} xs={24} sm={24}>
                              <ProductCard
                                // fromNewCatalog={fromNewCatalog}
                                data={item}
                                // onAdd={(e) => {
                                //   setConfigModal(true);
                                //   setProductId(item.id);
                                //   setProduct(item);
                                //   onOpenModal(item.price);
                                // }}
                                // onConfigure={(e) => {
                                //   setConfigModal(true);
                                //   setProductId(item.id);
                                //   setProduct(item);
                                //   onOpenModal(item.price);
                                // }}
                                // onDeactive={(e) => {
                                //   setIsOpenModal(true);
                                //   setProductId(item.id);
                                //   setProduct(item);
                                // }}
                              />
                            </Col>
                          );
                        })
                      ) : (
                        <Col span={24}>
                          {/* {isLoading && (
                            <img src={LoaderGif} height={"60"} width={"60"} />
                          )}
                          {!isLoading && (
                        )} */}
                          <Empty description={"Nothing to show right now."} />
                        </Col>
                      )}
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Card>
          <Row justify="center " style={{ border: "1px solid red " }}>
            <Col span={18}>
              <Row justify="end">
                <Col xl={10} xs={12} sm={12} md={6} lg={5}>
                  <Button
                    style={{
                      backgroundColor: "#26a69a",
                      color: "#fff",
                      width: "50%",
                    }}
                    onClick={() => this.props.onChangePreview()}
                  >
                    ADD MORE PRODUCTS
                  </Button>
                  <Button
                    style={{
                      backgroundColor: "#ff9800",
                      color: "#fff",
                      width: "50%",
                    }}
                    onClick={() => alert("HEllO")}
                  >
                    CONTINUE
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    products: store.CatalogReducer.products,
    metaData: store.CatalogReducer.metaData,
    categories: store.CatalogReducer.categories,
    shipingprice: store.CatalogReducer.shipingprice,
    basemixData: store.CatalogReducer.basemixData,
    isLoadingCategory: store.CatalogReducer.isLoadingCategorey,
    isLoading: store.CatalogReducer.isLodading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCategories: (params) => dispatch(CatalogAction.getCategoriesReq(params)),
    getProducts: (params, isTrue) =>
      dispatch(CatalogAction.getProductReq(params, isTrue)),
    updateShippingCost: (value, id) =>
      dispatch(CatalogAction.updateShipingCostReq(value, id)),
    getShippingCost: () => dispatch(CatalogAction.getShipingCostReq()),
    updateProduct: (value, id, active) =>
      dispatch(CatalogAction.updateProductReq(value, id, active)),
    postProduct: (payload) => dispatch(CatalogAction.postProductReq(payload)),
    basemixdata: (params) =>
      dispatch(CatalogAction.getBasemixCategoriesReq(params)),
    getbasemixes: (params) => dispatch(CatalogAction.getBasemixesReq(params)),
    getadditives: (params) => dispatch(CatalogAction.getAdditivesReq(params)),
    getbasemixesCategories: (params) =>
      dispatch(CatalogAction.getBasemixesCategoriesReq(params)),
    getTemplate: (params) => dispatch(CatalogAction.getTemplateReq(params)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(StorePreview);
